// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideScanSearch as RawLucideScanSearch } from "lucide-react";
export const LucideScanSearch = /* @__PURE__ */ createIcon(RawLucideScanSearch, "LucideScanSearch", 2);
